import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN + '/contests';

export default class Contest {

  static endpoints = {
    index : `${baseUrl}`
  };

  static titles = {
    1 : 'Referrals Contest',
    2 : 'Claims Contest',
  };

  static async getActiveContests () {
    return axios.get(`${baseUrl}/show`).then((response)=> response.data.activeContest);
  }

  static async getContestTop (id) {
    return axios.get(`${baseUrl}/${id}/top`).then((response)=> response.data.top);
  }

  static async getPreviousWinners(id) {
    return axios.get(`${baseUrl}/${id}/previous-winners`).then((response)=> response.data.previousWinners);
  }

  static async getRewardsList(id) {
    return axios.get(`${baseUrl}/${id}/rewards-list`).then((response)=> response.data.rewards);
  }

  static async getUserPoints(id, userId) {
    return axios.get(`${baseUrl}/${id}/user/${userId}/points`, {userId}).then((response)=> response.data.points);
  }

}
